import { render } from "./IconBtn.vue?vue&type=template&id=e3368d46&scoped=true"
import script from "./IconBtn.vue?vue&type=script&lang=js"
export * from "./IconBtn.vue?vue&type=script&lang=js"

import "./IconBtn.vue?vue&type=style&index=0&id=e3368d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3368d46"]])

export default __exports__